
import { Component, Prop, Vue } from "vue-property-decorator";
import lob from "lodash/object";
import startsWith from "lodash/startsWith";
import endsWith from "lodash/endsWith";

@Component({
  components: {}
})
export default class MenuItem extends Vue {
  @Prop() item: any;

  get btnClass(): string {
    var cls  = ["btn", "btnitem"];
    let extraCls = lob.get(this.item, "class", "");
    cls.push(extraCls);
    if(this.isCurrentUrlMatch || this.item.active){
      cls.push("active");
    }
    return cls.join(" ");
  }
  get isCurrentUrlMatch(): boolean {
      var currentHref = this.item.href;
      var browserPath = window.location.pathname;
      if(startsWith(currentHref,"..")) {
        var newHref = currentHref.replace("..","");
        if(endsWith(browserPath,newHref)) {
          return true;
        }
        return false;
        } else {
          if(endsWith(browserPath,currentHref)){
            return true;
          }
          return false;
        }
  }

  get label(): string {
    return lob.get(this.item, "label", "");
  }

  get href(): string {
    return lob.get(this.item, "href", "#");
  }


  onClick(){
    let callback = lob.get(this.item, "callback", undefined);
    if(callback){
      callback();
    }
  }
}
